<template>
  <div :class="{ 'kpi-card-highlighted': value.isCritical }" class="kpi-card">
    <v-card
      flat
      color="secondary lighten-2"
    >
      <v-row
        no-gutters
        align="center"
        justify="center"
      >
        <v-col
          cols="grow"
          class="text-center white--text headline"
          v-text="value.name"
        />
        <v-col cols="auto">
          <span
            :class="$options.colors[value.color]"
            class="mx-1 px-2 lighten-1 rounded-pill white--text subtitle-2"
            v-text="average"
          />
          <span
            :class="$options.colors[value.color]"
            class="mx-1 px-2 lighten-1 rounded-pill white--text subtitle-2"
            v-text="nbDemand"
          />
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import Helpers from 'src/utils/helpers'

export default {
  name: 'KpiCard',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    averageLetter () {
      return this.$t('animation.multiproject.general.averageFirstLetter')
    },
    nbDemandLetter () {
      return this.$t('animation.multiproject.general.demandFirstLetter')
    },
    average () {
      const value = Helpers.round(this.value.average, 1)
      return `${this.averageLetter} ${value}`
    },
    nbDemand () {
      const value = Helpers.round(this.value.nbDemand, 1)
      return `${this.nbDemandLetter} ${value}`
    },
  },
  colors: {
    red: 'red',
    green: 'green',
    yellow: 'amber',
    blue: 'indigo',
  },
}
</script>

<style lang="scss" scoped>
  .kpi-card {
    margin: 3px;
    padding: 1px;
  }

  .kpi-card-highlighted {
    margin: 0px;
    border: 3px dashed red;
    border-radius: 5px;
  }
</style>
